import * as React from 'react';
import { PVABadge } from './PVABadge';
import { PVAStyleModal, PonderaModal } from '../../inclinationmodals';
import { NavLink } from 'react-router-dom';
import { Style, StyleText } from '../../../models';
import './PVAStyle.css';
import { NotificationService, StyleDataService } from '../../../services';

interface PVAStyleProps {
    style: Style;
    brief: string;
    content: string;
    core?: String;
    hideViewAll?: boolean;
    name: string;
    notificationService: NotificationService;
}

interface PVAStyleModalState {
    modalVisible: boolean;
    modalSubVisible: boolean;
    modalsVisible: boolean[];
}

export class PVAStyle extends React.Component<PVAStyleProps, PVAStyleModalState> {
    private styleDataService = new StyleDataService(this.props.notificationService);

    constructor(props: PVAStyleProps) {
        super(props);

        var modalsVisible: boolean[] = [];
        this.props.style.styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).map((styleText: StyleText) => {
            modalsVisible.push(false);
        });

        this.state = {
            modalVisible: false,
            modalsVisible: modalsVisible,
            modalSubVisible: false
        };
    }

    toggleModal() {
        this.setState({ modalVisible: !this.state.modalVisible });
    }

    toggleModals(ind: number) {
        var arr = this.state.modalsVisible;
        arr[ind] = !arr[ind];
        this.setState({
            modalsVisible: arr
        });
    }

    toggleModalSub() {
        this.setState({ modalSubVisible: !this.state.modalSubVisible });
    }

    text(key: string) {
        if (this.props.style.styleTexts) {
            var st = this.props.style.styleTexts.find((s: StyleText) => {
                return s.styleTextType === key;
            });
            if (st) {
                return st.value;
            }
        }
        return '';
    }

    render() {
        const modalProps = {
            show: this.state.modalVisible,
            onHide: this.toggleModal.bind(this),
            title: 'PVA Style - ' + this.props.style,
            content: this.props.content,
            style: this.props.style,
            name: this.props.name
        };

        const sortedAdditionalStyles = this.props.style.styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'additional';
        }).sort((one: StyleText, two: StyleText) => {
            if (one.sort > two.sort) { 
                return 1; 
            } else if (one.sort < two.sort) { 
                return -1; 
            }
            return 0;
        });

        const subCoreStyles = this.props.style.styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'subCore';
        });

        var subCore = (
            <small>
                {this.props.style.subCore && <a className="subCoreLink" onClick={() => this.setState({modalSubVisible: true})}>{this.props.style.subCore.name}</a>}
                {!this.props.style.subCore && this.props.core}
            </small>
        );

        if (this.props.style.useSecondaryStyle) {
            subCore = (
                <small>
                    <a className="subCoreLink" onClick={() => this.setState({modalSubVisible: true})}>{this.props.style.secondaryStyle.name}</a>
                </small>);
        }

        return (
            <div className={`pva-style ${this.props.style}`}>
                <img className="pva-style-image" src={`images/pvaStyleGraphic_${this.props.style.name}.svg`} />
                <PVABadge style={this.props.style.name} badge={this.props.style.name[0]} />
                <div className="pva-style-content">
                    <h5>PVA Style</h5>
                    <h3>{this.props.style.name} {!this.props.hideViewAll && subCore}</h3>
                    <div className="brief" dangerouslySetInnerHTML={{ __html: this.text('brief')}} />
                    <div className="pva-style-button-container">
                        <a className="btn btn-primary pva-style-buttons" onClick={(e) => this.setState({modalVisible: true})}>Read More</a>
                        {!this.props.hideViewAll && <NavLink to={'/pvastyles'} className="btn btn-default pva-style-buttons">
                            View All PVA Styles
                        </NavLink>}
                        {this.props.hideViewAll && sortedAdditionalStyles.map((styleText: StyleText, ind: number) => {
                            return <a key={`st-${ind}`} className="btn btn-default pva-style-buttons" onClick={(e) => this.toggleModals(ind)}>
                                {styleText.keyName}
                            </a>;
                        })}
                    </div>
                </div>
                <PVAStyleModal styleDataService={this.styleDataService} notificationService={this.props.notificationService} {...modalProps} />

                {this.props.hideViewAll && sortedAdditionalStyles.map((styleText: StyleText, ind: number) => {
                    return <div key={`st2-${ind}`}>
                        <PonderaModal style={this.props.style} simpleTitle={true} useStyleNameInHeader={true} show={this.state.modalsVisible[ind]} title={styleText.keyName} content={styleText.value} onHide={(e: any) => this.toggleModals(ind)} />
                        </div>;
                })}

                {!this.props.hideViewAll && (this.props.style.subCore || this.props.style.useSecondaryStyle) && subCoreStyles.length > 0 && subCoreStyles.map((styleText: StyleText, ind: number) => {
                    return <div key={`st2-subCore-${ind}`}>
                        {this.props.style.useSecondaryStyle && <PonderaModal
                            style={this.props.style}
                            simpleTitle={true}
                            show={this.state.modalSubVisible}
                            title={this.props.style.name + ' <span style="font-size:70%">with a Secondary Style of ' + this.props.style.secondaryStyle.name + '</span>'}
                            content={styleText.value}
                            onHide={(e: any) => this.toggleModalSub()}
                        />}
                        {!this.props.style.useSecondaryStyle && <PonderaModal style={this.props.style} simpleTitle={true} show={this.state.modalSubVisible} title={this.props.style.subCore.name} content={styleText.value} onHide={(e: any) => this.toggleModalSub()} />}
                    </div>;
                })}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAStyle.tsx